import React from "react";
import { motion } from "framer-motion";

import Header from "../components/Header";
import Footer from "../components/Footer";

import pic1 from "../assest/CampDetails/SIDDHARTHA CREATIVE SCHOOL pic-1.jpg";
import pic2 from "../assest/CampDetails/SIDDHARTHA CREATIVE SCHOOL pic-2.jpg";
import pic3 from "../assest/CampDetails/SRI S.S.R. HIGH SCHOOL pic-1.jpg";
import pic4 from "../assest/CampDetails/SRI S.S.R. HIGH SCHOOL pic-2.jpg";
import pic5 from "../assest/CampDetails/LAHARI VIDYA MANDIR SCHOOL pic-1.jpg";
import pic6 from "../assest/CampDetails/LAHARI VIDYA MANDIR SCHOOL pic-2.jpg";
import pic7 from "../assest/CampDetails/LAHARI VIDYA MANDIR SCHOOL2 pic-1.jpg";
import pic8 from "../assest/CampDetails/LAHARI VIDYA MANDIR SCHOOL2 pic-2.jpg";
import pic9 from "../assest/CampDetails/VOWEL TECHLON SCHOOL pic-1.jpg";
import pic10 from "../assest/CampDetails/VOWEL TECHLON SCHOOL pic-2.jpg";
import pic11 from "../assest/CampDetails/B.V SCHOOL pic-1.jpg";
import pic12 from "../assest/CampDetails/B.V SCHOOL pic-2.jpg";
import pic13 from "../assest/CampDetails/M.K. GANDHI PUBLIC SCHOOL pic-1.jpg";
import pic14 from "../assest/CampDetails/M.K. GANDHI PUBLIC SCHOOL pic-2.jpg";
import pic15 from "../assest/CampDetails/INDIAN SPRINGS EM HIGH SCHOOL pic-1.jpg";
import pic16 from "../assest/CampDetails/INDIAN SPRINGS EM HIGH SCHOOL pic-2.jpg";
import pic17 from "../assest/CampDetails/INDIAN SPRINGS EM HIGH SCHOOL2 pic-1.jpg";
import pic18 from "../assest/CampDetails/INDIAN SPRINGS EM HIGH SCHOOL2 pic-2.jpg";
import pic19 from "../assest/CampDetails/ARAVINDA MODEL SCHOOL pic-1.jpg";
import pic20 from "../assest/CampDetails/ARAVINDA MODEL SCHOOL pic-2.jpg";
import pic21 from "../assest/CampDetails/ARAVINDA HIGH SCHOOL pic-1.jpg";
import pic22 from "../assest/CampDetails/ARAVINDA HIGH SCHOOL pic-2.jpg";
import pic23 from "../assest/CampDetails/MARIS STELLA COLLEGE pic-1.jpg";
import pic24 from "../assest/CampDetails/MARIS STELLA COLLEGE pic-2.jpg";
import pic25 from "../assest/CampDetails/SARADA RAMAKRISHNA SCHOOL pic-1.jpg";
import pic26 from "../assest/CampDetails/SARADA RAMAKRISHNA SCHOOL pic-2.jpg";
import pic27 from "../assest/CampDetails/SARADA DEGREE COLLEGE pic-1.jpg";
import pic28 from "../assest/CampDetails/SARADA DEGREE COLLEGE pic-2.jpg";
import pic29 from "../assest/CampDetails/NETAJI SCHOOL pic-1.jpg";
import pic30 from "../assest/CampDetails/NETAJI SCHOOL pic-2.jpg";
import pic31 from "../assest/CampDetails/BISHOP AZARIAH ELE SCHOOL pic-1.jpg";
import pic32 from "../assest/CampDetails/BISHOP AZARIAH ELE SCHOOL pic-2.jpg";
import pic33 from "../assest/CampDetails/BISHOP AZARIAH E.M HIGH SCHOOL pic-1.jpg";
import pic34 from "../assest/CampDetails/BISHOP AZARIAH E.M HIGH SCHOOL pic-2.jpg";
import pic35 from "../assest/CampDetails/BISHOP AZARIAH HIGH SCHOOL pic-1.jpg";
import pic36 from "../assest/CampDetails/BISHOP AZARIAH HIGH SCHOOL pic-2.jpg";
import pic37 from "../assest/CampDetails/A.D.M.C. HIGH SCHOOL pic-1.jpg";
import pic38 from "../assest/CampDetails/A.D.M.C. HIGH SCHOOL pic-2.jpg";
import pic39 from "../assest/CampDetails/A.D.M.C.ELE SCHOOL pic-1.jpg";
import pic40 from "../assest/CampDetails/A.D.M.C.ELE SCHOOL pic-2.jpg";
import pic41 from "../assest/CampDetails/S.B.V.S.R.M.C.ELE SCHOOL pic-1.jpg";
import pic42 from "../assest/CampDetails/S.B.V.S.R.M.C.ELE SCHOOL pic-2.jpg";
import pic43 from "../assest/CampDetails/A.P.J. ABDUL KALAM M.C.H. SCHOOL pic-1.jpg";
import pic44 from "../assest/CampDetails/A.P.J. ABDUL KALAM M.C.H. SCHOOL pic-2.jpg";
import pic45 from "../assest/CampDetails/M.C. URDU ELE SCHOOL pic-1.jpg";
import pic46 from "../assest/CampDetails/M.C. URDU ELE SCHOOL pic-2.jpg";
import pic47 from "../assest/CampDetails/CARE & SHARE.M.C. HIGH SCHOOL pic-1.jpg";
import pic48 from "../assest/CampDetails/CARE & SHARE.M.C. HIGH SCHOOL pic-2.jpg";
import pic49 from "../assest/CampDetails/CARE & SHARE.M.C.ELE SCHOOL pic-1.jpg";
import pic50 from "../assest/CampDetails/CARE & SHARE.M.C.ELE SCHOOL pic-2.jpg";
import pic51 from "../assest/CampDetails/SRI B.V. SUBBA REDDY.M.C.H. SCHOOL pic-1.jpg";
import pic52 from "../assest/CampDetails/SRI B.V. SUBBA REDDY.M.C.H. SCHOOL pic-2.jpg";
import pic53 from "../assest/CampDetails/MK.BAIG.M.C.ELE SCHOOL pic-1.jpg";
import pic54 from "../assest/CampDetails/MK.BAIG.M.C.ELE SCHOOL pic-2.jpg";
import pic55 from "../assest/CampDetails/MK. BAIG.M.C. HIGH SCHOOL pic-1.jpg";
import pic56 from "../assest/CampDetails/MK. BAIG.M.C. HIGH SCHOOL pic-2.jpg";
import pic57 from "../assest/CampDetails/C.P.R.Z.P.H. SCHOOL pic-1.jpg";
import pic58 from "../assest/CampDetails/C.P.R.Z.P.H. SCHOOL pic-2.jpg";
import pic59 from "../assest/CampDetails/DR.JD.M.M.C.ELE SCHOOL pic-1.jpg";
import pic60 from "../assest/CampDetails/DR.JD.M.M.C.ELE SCHOOL pic-2.jpg";












const CampDetails = () => {
  return (
    <>
      <Header />

      <section className="py-10 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-6">

          {/* TITLE */}
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-3xl md:text-4xl font-bold text-slate-900 mb-6"
          >
            Camp Details
          </motion.h1>


          {/* ================= CAMP 1 ================= */}
          {/* DESCRIPTION 1 */}
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="text-slate-600 text-base md:text-lg mb-8 leading-relaxed"
          >
            SIDDHARTHA CREATIVE SCHOOL, OLD R.R.PET, VIJAYAWADA
            <br />
            DATE OF THE CHECK UP CAMP: 09.09.2017
          </motion.p>

          <div className="flex flex-col lg:flex-row md:flex-row gap-6 mb-16">

            {/* TABLE 1 */}
            <div className="w-full lg:w-3/4 md:w-1/2">
              <div className="overflow-x-auto">
                <table className="w-full border border-slate-200 rounded-lg overflow-hidden">
                  <thead className="bg-slate-100 text-slate-700">
                    <tr>
                      <th className="p-3 text-left">S. No</th>
                      <th className="p-3 text-left">Diagnosis</th>
                      <th className="p-3 text-center">Suffered Students</th>
                    </tr>
                  </thead>

                  <tbody className="text-slate-600">
                    <tr className="border-t"> <td className="p-3">1</td> <td className="p-3">PLAQUE</td> <td className="p-3 text-center">90</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">2</td> <td className="p-3">CALCULUS</td> <td className="p-3 text-center">85</td> </tr>
                    <tr className="border-t"> <td className="p-3">3</td> <td className="p-3">CARIES</td> <td className="p-3 text-center">99</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">4</td> <td className="p-3">MISSING TEETH</td> <td className="p-3 text-center">22</td> </tr>
                    <tr className="border-t"> <td className="p-3">5</td> <td className="p-3">MALOCCLUSION</td> <td className="p-3 text-center">18</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">6</td> <td className="p-3">NORMAL</td> <td className="p-3 text-center">136</td> </tr>
                    {/* Total Row */}
                    <tr className="border-t bg-slate-200 font-bold">
                      <td
                        colSpan="2"
                        className="p-3 text-center text-slate-800"
                      >
                        TOTAL NO. OF STUDENTS
                      </td>
                      <td className="p-3 text-center text-slate-800">
                        450
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            {/* IMAGES 1 */}
            <div className="w-full lg:w-1/4 md:w-1/2 flex flex-col gap-4">
              <motion.div
                whileHover={{ scale: 1.03 }}
                className="rounded-xl overflow-hidden shadow-md"
              >
                <img
                  src={pic1}
                  alt=""
                  className="w-full h-48 object-cover"
                />
              </motion.div>

              <motion.div
                whileHover={{ scale: 1.03 }}
                className="rounded-xl overflow-hidden shadow-md"
              >
                <img
                  src={pic2}
                  alt=""
                  className="w-full h-48 object-cover"
                />
              </motion.div>
            </div>

          </div>

          {/* ================= CAMP 2 ================= */}
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="text-slate-600 text-base md:text-lg mb-8 leading-relaxed"
          >
            SRI S.S.R. HIGH SCHOOL, OLD R.R.PET, VIJAYAWADA
            <br />
            DATE OF THE CHECK UP CAMP : 09.09.2017
          </motion.p>

          <div className="flex flex-col lg:flex-row md:flex-row gap-6">

            {/* TABLE 2 */}
            <div className="w-full lg:w-3/4 md:w-1/2">
              <div className="overflow-x-auto">
                <table className="w-full border border-slate-200 rounded-lg overflow-hidden">
                  <thead className="bg-slate-100 text-slate-700">
                    <tr>
                      <th className="p-3 text-left">S. No</th>
                      <th className="p-3 text-left">Diagnosis</th>
                      <th className="p-3 text-center">Suffered Students</th>
                    </tr>
                  </thead>

                  <tbody className="text-slate-600">
                    <tr className="border-t"> <td className="p-3">1</td> <td className="p-3">PLAQUE</td> <td className="p-3 text-center">99</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">2</td> <td className="p-3">CALCULUS</td> <td className="p-3 text-center">93</td> </tr>
                    <tr className="border-t"> <td className="p-3">3</td> <td className="p-3">CARIES</td> <td className="p-3 text-center">126</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">4</td> <td className="p-3">MISSING TEETH</td> <td className="p-3 text-center">17</td> </tr>
                    <tr className="border-t"> <td className="p-3">5</td> <td className="p-3">MALOCCLUSION</td> <td className="p-3 text-center">19</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">6</td> <td className="p-3">NORMAL</td> <td className="p-3 text-center">196</td> </tr>
                    {/* Total Row */}
                    <tr className="border-t bg-slate-200 font-bold">
                      <td
                        colSpan="2"
                        className="p-3 text-center text-slate-800"
                      >
                        TOTAL NO. OF STUDENTS
                      </td>
                      <td className="p-3 text-center text-slate-800">
                        550
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            {/* IMAGES 2 */}
            <div className="w-full lg:w-1/4 md:w-1/2 flex flex-col gap-4">
              <motion.div
                whileHover={{ scale: 1.03 }}
                className="rounded-xl overflow-hidden shadow-md"
              >
                <img
                  src={pic3}
                  alt=""
                  className="w-full h-48 object-cover"
                />
              </motion.div>

              <motion.div
                whileHover={{ scale: 1.03 }}
                className="rounded-xl overflow-hidden shadow-md"
              >
                <img
                  src={pic4}
                  alt=""
                  className="w-full h-48 object-cover"
                />
              </motion.div>
            </div>

          </div>

          {/* ================= CAMP 3 ================= */}
<motion.p
  initial={{ opacity: 0 }}
  whileInView={{ opacity: 1 }}
  viewport={{ once: true }}
  className="text-slate-600 text-base md:text-lg mb-8 leading-relaxed mt-16"
>
  LAHARI VIDYA MANDIR SCHOOL, RAJIV NAGAR, VIJAYAWADA
  <br />
  DATE OF THE CHECK UP CAMP: 08.09.2017
</motion.p>

<div className="flex flex-col lg:flex-row md:flex-row gap-6">

  {/* TABLE 3 */}
  <div className="w-full lg:w-3/4 md:w-1/2">
    <div className="overflow-x-auto">
      <table className="w-full border border-slate-200 rounded-lg overflow-hidden">

        <thead className="bg-slate-100 text-slate-700">
          <tr>
            <th className="p-3 text-left">S. No</th>
            <th className="p-3 text-left">Diagnosis</th>
            <th className="p-3 text-center">Suffered Students</th>
          </tr>
        </thead>
                  <tbody className="text-slate-600">
                    <tr className="border-t"> <td className="p-3">1</td> <td className="p-3">PLAQUE</td> <td className="p-3 text-center">135</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">2</td> <td className="p-3">CALCULUS</td> <td className="p-3 text-center">90</td> </tr>
                    <tr className="border-t"> <td className="p-3">3</td> <td className="p-3">CARIES</td> <td className="p-3 text-center">105</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">4</td> <td className="p-3">MISSING TEETH</td> <td className="p-3 text-center">28</td> </tr>
                    <tr className="border-t"> <td className="p-3">5</td> <td className="p-3">MALOCCLUSION</td> <td className="p-3 text-center">27</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">6</td> <td className="p-3">NORMAL</td> <td className="p-3 text-center">115</td> </tr>
                    {/* Total Row */}
                    <tr className="border-t bg-slate-200 font-bold">
                      <td
                        colSpan="2"
                        className="p-3 text-center text-slate-800"
                      >
                        TOTAL NO. OF STUDENTS
                      </td>
                      <td className="p-3 text-center text-slate-800">
                        500
                      </td>
                    </tr>
                  </tbody>
      </table>
    </div>
  </div>

  {/* IMAGES 3 */}
  <div className="w-full lg:w-1/4 md:w-1/2 flex flex-col gap-4">

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic5}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic6}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

  </div>

</div>

{/* ================= CAMP 4 ================= */}
<motion.p
  initial={{ opacity: 0 }}
  whileInView={{ opacity: 1 }}
  viewport={{ once: true }}
  className="text-slate-600 text-base md:text-lg mb-8 leading-relaxed mt-16"
>
  LAHARI VIDYA MANDIR SCHOOL, PRAKASH NAGAR, VIJAYAWADA
  <br />
  DATE OF THE CHECK UP CAMP: 08.09.2017
</motion.p>

<div className="flex flex-col lg:flex-row md:flex-row gap-6">

  {/* TABLE 4 */}
  <div className="w-full lg:w-3/4 md:w-1/2">
    <div className="overflow-x-auto">
      <table className="w-full border border-slate-200 rounded-lg overflow-hidden">

        <thead className="bg-slate-100 text-slate-700">
          <tr>
            <th className="p-3 text-left">S. No</th>
            <th className="p-3 text-left">Diagnosis</th>
            <th className="p-3 text-center">Suffered Students</th>
          </tr>
        </thead>

                  <tbody className="text-slate-600">
                    <tr className="border-t"> <td className="p-3">1</td> <td className="p-3">PLAQUE</td> <td className="p-3 text-center">252</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">2</td> <td className="p-3">CALCULUS</td> <td className="p-3 text-center">189</td> </tr>
                    <tr className="border-t"> <td className="p-3">3</td> <td className="p-3">CARIES</td> <td className="p-3 text-center">173</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">4</td> <td className="p-3">MISSING TEETH</td> <td className="p-3 text-center">58</td> </tr>
                    <tr className="border-t"> <td className="p-3">5</td> <td className="p-3">MALOCCLUSION</td> <td className="p-3 text-center">48</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">6</td> <td className="p-3">NORMAL</td> <td className="p-3 text-center">330</td> </tr>
                    {/* Total Row */}
                    <tr className="border-t bg-slate-200 font-bold">
                      <td
                        colSpan="2"
                        className="p-3 text-center text-slate-800"
                      >
                        TOTAL NO. OF STUDENTS
                      </td>
                      <td className="p-3 text-center text-slate-800">
                        1050
                      </td>
                    </tr>
                  </tbody>
      </table>
    </div>
  </div>

  {/* IMAGES 4 */}
  <div className="w-full lg:w-1/4 md:w-1/2 flex flex-col gap-4">

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic7}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic8}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

  </div>

</div>

{/* ================= CAMP 5 ================= */}
<motion.p
  initial={{ opacity: 0 }}
  whileInView={{ opacity: 1 }}
  viewport={{ once: true }}
  className="text-slate-600 text-base md:text-lg mb-8 leading-relaxed mt-16"
>
  VOWEL TECHLON SCHOOL, RAMAVARAPADU, VIJAYAWADA
  <br />
  DATE OF THE CHECK UP CAMP: 07.09.2017
</motion.p>

<div className="flex flex-col lg:flex-row md:flex-row gap-6">

  {/* TABLE 5 */}
  <div className="w-full lg:w-3/4 md:w-1/2">
    <div className="overflow-x-auto">
      <table className="w-full border border-slate-200 rounded-lg overflow-hidden">

        <thead className="bg-slate-100 text-slate-700">
          <tr>
            <th className="p-3 text-left">S. No</th>
            <th className="p-3 text-left">Diagnosis</th>
            <th className="p-3 text-center">Suffered Students</th>
          </tr>
        </thead>

                  <tbody className="text-slate-600">
                    <tr className="border-t"> <td className="p-3">1</td> <td className="p-3">PLAQUE</td> <td className="p-3 text-center">43</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">2</td> <td className="p-3">CALCULUS</td> <td className="p-3 text-center">29</td> </tr>
                    <tr className="border-t"> <td className="p-3">3</td> <td className="p-3">CARIES</td> <td className="p-3 text-center">51</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">4</td> <td className="p-3">MISSING TEETH</td> <td className="p-3 text-center">9</td> </tr>
                    <tr className="border-t"> <td className="p-3">5</td> <td className="p-3">MALOCCLUSION</td> <td className="p-3 text-center">9</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">6</td> <td className="p-3">NORMAL</td> <td className="p-3 text-center">20</td> </tr>
                    {/* Total Row */}
                    <tr className="border-t bg-slate-200 font-bold">
                      <td
                        colSpan="2"
                        className="p-3 text-center text-slate-800"
                      >
                        TOTAL NO. OF STUDENTS
                      </td>
                      <td className="p-3 text-center text-slate-800">
                        161
                      </td>
                    </tr>
                  </tbody>
      </table>
    </div>
  </div>

  {/* IMAGES 5 */}
  <div className="w-full lg:w-1/4 md:w-1/2 flex flex-col gap-4">

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic9}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic10}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

  </div>

</div>

{/* ================= CAMP 6 ================= */}
<motion.p
  initial={{ opacity: 0 }}
  whileInView={{ opacity: 1 }}
  viewport={{ once: true }}
  className="text-slate-600 text-base md:text-lg mb-8 leading-relaxed mt-16"
>
  B.V SCHOOL, AYYAPPA NAGAR, VIJAYAWADA
  <br />
  DATE OF THE CHECK UP CAMP: 07.09.2017
</motion.p>

<div className="flex flex-col lg:flex-row md:flex-row gap-6">

  {/* TABLE 6 */}
  <div className="w-full lg:w-3/4 md:w-1/2">
    <div className="overflow-x-auto">
      <table className="w-full border border-slate-200 rounded-lg overflow-hidden">

        <thead className="bg-slate-100 text-slate-700">
          <tr>
            <th className="p-3 text-left">S. No</th>
            <th className="p-3 text-left">Diagnosis</th>
            <th className="p-3 text-center">Suffered Students</th>
          </tr>
        </thead>

                  <tbody className="text-slate-600">
                    <tr className="border-t"> <td className="p-3">1</td> <td className="p-3">PLAQUE</td> <td className="p-3 text-center">304</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">2</td> <td className="p-3">CALCULUS</td> <td className="p-3 text-center">246</td> </tr>
                    <tr className="border-t"> <td className="p-3">3</td> <td className="p-3">CARIES</td> <td className="p-3 text-center">362</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">4</td> <td className="p-3">MISSING TEETH</td> <td className="p-3 text-center">61</td> </tr>
                    <tr className="border-t"> <td className="p-3">5</td> <td className="p-3">MALOCCLUSION</td> <td className="p-3 text-center">58</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">6</td> <td className="p-3">NORMAL</td> <td className="p-3 text-center">419</td> </tr>
                    {/* Total Row */}
                    <tr className="border-t bg-slate-200 font-bold">
                      <td
                        colSpan="2"
                        className="p-3 text-center text-slate-800"
                      >
                        TOTAL NO. OF STUDENTS
                      </td>
                      <td className="p-3 text-center text-slate-800">
                        1450
                      </td>
                    </tr>
                  </tbody>
      </table>
    </div>
  </div>

  {/* IMAGES 6 */}
  <div className="w-full lg:w-1/4 md:w-1/2 flex flex-col gap-4">

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic11}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic12}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

  </div>

</div>
{/* ================= CAMP 7 ================= */}
<motion.p
  initial={{ opacity: 0 }}
  whileInView={{ opacity: 1 }}
  viewport={{ once: true }}
  className="text-slate-600 text-base md:text-lg mb-8 leading-relaxed mt-16"
>
  M.K. GANDHI PUBLIC SCHOOL, LABBIPETA, VIJAYAWADA
  <br />
  DATE OF THE CHECK UP CAMP: 06.09.2017
</motion.p>

<div className="flex flex-col lg:flex-row md:flex-row gap-6">

  {/* TABLE 7 */}
  <div className="w-full lg:w-3/4 md:w-1/2">
    <div className="overflow-x-auto">
      <table className="w-full border border-slate-200 rounded-lg overflow-hidden">

        <thead className="bg-slate-100 text-slate-700">
          <tr>
            <th className="p-3 text-left">S. No</th>
            <th className="p-3 text-left">Diagnosis</th>
            <th className="p-3 text-center">Suffered Students</th>
          </tr>
        </thead>

                  <tbody className="text-slate-600">
                    <tr className="border-t"> <td className="p-3">1</td> <td className="p-3">PLAQUE</td> <td className="p-3 text-center">115</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">2</td> <td className="p-3">CALCULUS</td> <td className="p-3 text-center">94</td> </tr>
                    <tr className="border-t"> <td className="p-3">3</td> <td className="p-3">CARIES</td> <td className="p-3 text-center">137</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">4</td> <td className="p-3">MISSING TEETH</td> <td className="p-3 text-center">26</td> </tr>
                    <tr className="border-t"> <td className="p-3">5</td> <td className="p-3">MALOCCLUSION</td> <td className="p-3 text-center">28</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">6</td> <td className="p-3">NORMAL</td> <td className="p-3 text-center">125</td> </tr>
                    {/* Total Row */}
                    <tr className="border-t bg-slate-200 font-bold">
                      <td
                        colSpan="2"
                        className="p-3 text-center text-slate-800"
                      >
                        TOTAL NO. OF STUDENTS
                      </td>
                      <td className="p-3 text-center text-slate-800">
                        525
                      </td>
                    </tr>
                  </tbody>
      </table>
    </div>
  </div>

  {/* IMAGES 7 */}
  <div className="w-full lg:w-1/4 md:w-1/2 flex flex-col gap-4">

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic13}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic14}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

  </div>

</div>
{/* ================= CAMP 8 ================= */}
<motion.p
  initial={{ opacity: 0 }}
  whileInView={{ opacity: 1 }}
  viewport={{ once: true }}
  className="text-slate-600 text-base md:text-lg mb-8 leading-relaxed mt-16"
>
  INDIAN SPRINGS EM HIGH SCHOOL, PATAMATA, VIJAYAWADA
  <br />
  DATE OF THE CHECK UP CAMP: 04.09.2017
</motion.p>

<div className="flex flex-col lg:flex-row md:flex-row gap-6">

  {/* TABLE 8 */}
  <div className="w-full lg:w-3/4 md:w-1/2">
    <div className="overflow-x-auto">
      <table className="w-full border border-slate-200 rounded-lg overflow-hidden">

        <thead className="bg-slate-100 text-slate-700">
          <tr>
            <th className="p-3 text-left">S. No</th>
            <th className="p-3 text-left">Diagnosis</th>
            <th className="p-3 text-center">Suffered Students</th>
          </tr>
        </thead>

                  <tbody className="text-slate-600">
                    <tr className="border-t"> <td className="p-3">1</td> <td className="p-3">PLAQUE</td> <td className="p-3 text-center">141</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">2</td> <td className="p-3">CALCULUS</td> <td className="p-3 text-center">110</td> </tr>
                    <tr className="border-t"> <td className="p-3">3</td> <td className="p-3">CARIES</td> <td className="p-3 text-center">160</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">4</td> <td className="p-3">MISSING TEETH</td> <td className="p-3 text-center">31</td> </tr>
                    <tr className="border-t"> <td className="p-3">5</td> <td className="p-3">MALOCCLUSION</td> <td className="p-3 text-center">33</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">6</td> <td className="p-3">NORMAL</td> <td className="p-3 text-center">140</td> </tr>
                    {/* Total Row */}
                    <tr className="border-t bg-slate-200 font-bold">
                      <td
                        colSpan="2"
                        className="p-3 text-center text-slate-800"
                      >
                        TOTAL NO. OF STUDENTS
                      </td>
                      <td className="p-3 text-center text-slate-800">
                        615
                      </td>
                    </tr>
                  </tbody>
      </table>
    </div>
  </div>

  {/* IMAGES 8 */}
  <div className="w-full lg:w-1/4 md:w-1/2 flex flex-col gap-4">

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic15}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic16}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

  </div>

</div>
{/* ================= CAMP 9 ================= */}
<motion.p
  initial={{ opacity: 0 }}
  whileInView={{ opacity: 1 }}
  viewport={{ once: true }}
  className="text-slate-600 text-base md:text-lg mb-8 leading-relaxed mt-16"
>
  INDIAN SPRINGS EM HIGH SCHOOL, GOLLAPUDI, VIJAYAWADA
  <br />
  DATE OF THE CHECK UP CAMP: 31.08.2017
</motion.p>

<div className="flex flex-col lg:flex-row md:flex-row gap-6">

  {/* TABLE 9 */}
  <div className="w-full lg:w-3/4 md:w-1/2">
    <div className="overflow-x-auto">
      <table className="w-full border border-slate-200 rounded-lg overflow-hidden">

        <thead className="bg-slate-100 text-slate-700">
          <tr>
            <th className="p-3 text-left">S. No</th>
            <th className="p-3 text-left">Diagnosis</th>
            <th className="p-3 text-center">Suffered Students</th>
          </tr>
        </thead>

                  <tbody className="text-slate-600">
                    <tr className="border-t"> <td className="p-3">1</td> <td className="p-3">PLAQUE</td> <td className="p-3 text-center">164</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">2</td> <td className="p-3">CALCULUS</td> <td className="p-3 text-center">128</td> </tr>
                    <tr className="border-t"> <td className="p-3">3</td> <td className="p-3">CARIES</td> <td className="p-3 text-center">186</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">4</td> <td className="p-3">MISSING TEETH</td> <td className="p-3 text-center">38</td> </tr>
                    <tr className="border-t"> <td className="p-3">5</td> <td className="p-3">MALOCCLUSION</td> <td className="p-3 text-center">35</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">6</td> <td className="p-3">NORMAL</td> <td className="p-3 text-center">165</td> </tr>
                    {/* Total Row */}
                    <tr className="border-t bg-slate-200 font-bold">
                      <td
                        colSpan="2"
                        className="p-3 text-center text-slate-800"
                      >
                        TOTAL NO. OF STUDENTS
                      </td>
                      <td className="p-3 text-center text-slate-800">
                        716
                      </td>
                    </tr>
                  </tbody>
      </table>
    </div>
  </div>

  {/* IMAGES 9 */}
  <div className="w-full lg:w-1/4 md:w-1/2 flex flex-col gap-4">

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic17}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic18}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

  </div>

</div>
{/* ================= CAMP 10 ================= */}
<motion.p
  initial={{ opacity: 0 }}
  whileInView={{ opacity: 1 }}
  viewport={{ once: true }}
  className="text-slate-600 text-base md:text-lg mb-8 leading-relaxed mt-16"
>
  ARAVINDA MODEL SCHOOL, NIDAMARRU ROAD, MANGALAGIRI
  <br />
  DATE OF THE CHECK UP CAMP: 29.08.2017
</motion.p>

<div className="flex flex-col lg:flex-row md:flex-row gap-6">

  {/* TABLE 10 */}
  <div className="w-full lg:w-3/4 md:w-1/2">
    <div className="overflow-x-auto">
      <table className="w-full border border-slate-200 rounded-lg overflow-hidden">

        <thead className="bg-slate-100 text-slate-700">
          <tr>
            <th className="p-3 text-left">S. No</th>
            <th className="p-3 text-left">Diagnosis</th>
            <th className="p-3 text-center">Suffered Students</th>
          </tr>
        </thead>

                  <tbody className="text-slate-600">
                    <tr className="border-t"> <td className="p-3">1</td> <td className="p-3">PLAQUE</td> <td className="p-3 text-center">181</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">2</td> <td className="p-3">CALCULUS</td> <td className="p-3 text-center">142</td> </tr>
                    <tr className="border-t"> <td className="p-3">3</td> <td className="p-3">CARIES</td> <td className="p-3 text-center">204</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">4</td> <td className="p-3">MISSING TEETH</td> <td className="p-3 text-center">43</td> </tr>
                    <tr className="border-t"> <td className="p-3">5</td> <td className="p-3">MALOCCLUSION</td> <td className="p-3 text-center">37</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">6</td> <td className="p-3">NORMAL</td> <td className="p-3 text-center">180</td> </tr>
                    {/* Total Row */}
                    <tr className="border-t bg-slate-200 font-bold">
                      <td
                        colSpan="2"
                        className="p-3 text-center text-slate-800"
                      >
                        TOTAL NO. OF STUDENTS
                      </td>
                      <td className="p-3 text-center text-slate-800">
                        787
                      </td>
                    </tr>
                  </tbody>
      </table>
    </div>
  </div>

  {/* IMAGES 10 */}
  <div className="w-full lg:w-1/4 md:w-1/2 flex flex-col gap-4">

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic19}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic20}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

  </div>

</div>
{/* ================= CAMP 11 ================= */}
<motion.p
  initial={{ opacity: 0 }}
  whileInView={{ opacity: 1 }}
  viewport={{ once: true }}
  className="text-slate-600 text-base md:text-lg mb-8 leading-relaxed mt-16"
>
  ARAVINDA HIGH SCHOOL, KUNCHANAPALLI, GUNTUR DIST
  <br />
  DATE OF THE CHECK UP CAMP: 28.08.2017
</motion.p>

<div className="flex flex-col lg:flex-row md:flex-row gap-6">

  {/* TABLE 11 */}
  <div className="w-full lg:w-3/4 md:w-1/2">
    <div className="overflow-x-auto">
      <table className="w-full border border-slate-200 rounded-lg overflow-hidden">

        <thead className="bg-slate-100 text-slate-700">
          <tr>
            <th className="p-3 text-left">S. No</th>
            <th className="p-3 text-left">Diagnosis</th>
            <th className="p-3 text-center">Suffered Students</th>
          </tr>
        </thead>

                  <tbody className="text-slate-600">
                    <tr className="border-t"> <td className="p-3">1</td> <td className="p-3">PLAQUE</td> <td className="p-3 text-center">460</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">2</td> <td className="p-3">CALCULUS</td> <td className="p-3 text-center">360</td> </tr>
                    <tr className="border-t"> <td className="p-3">3</td> <td className="p-3">CARIES</td> <td className="p-3 text-center">420</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">4</td> <td className="p-3">MISSING TEETH</td> <td className="p-3 text-center">116</td> </tr>
                    <tr className="border-t"> <td className="p-3">5</td> <td className="p-3">MALOCCLUSION</td> <td className="p-3 text-center">84</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">6</td> <td className="p-3">NORMAL</td> <td className="p-3 text-center">560</td> </tr>
                    {/* Total Row */}
                    <tr className="border-t bg-slate-200 font-bold">
                      <td
                        colSpan="2"
                        className="p-3 text-center text-slate-800"
                      >
                        TOTAL NO. OF STUDENTS
                      </td>
                      <td className="p-3 text-center text-slate-800">
                        2000
                      </td>
                    </tr>
                  </tbody>
      </table>
    </div>
  </div>

  {/* IMAGES 11 */}
  <div className="w-full lg:w-1/4 md:w-1/2 flex flex-col gap-4">

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic21}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic22}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

  </div>

</div>
{/* ================= CAMP 12 ================= */}
<motion.p
  initial={{ opacity: 0 }}
  whileInView={{ opacity: 1 }}
  viewport={{ once: true }}
  className="text-slate-600 text-base md:text-lg mb-8 leading-relaxed mt-16"
>
  MARIS STELLA COLLEGE, VIJAYAWADA
  <br />
  DATES OF THE CHECK UP CAMP: 22.08.2017	AND 23.08.2017
</motion.p>

<div className="flex flex-col lg:flex-row md:flex-row gap-6">

  {/* TABLE 12 */}
  <div className="w-full lg:w-3/4 md:w-1/2">
    <div className="overflow-x-auto">
      <table className="w-full border border-slate-200 rounded-lg overflow-hidden">

        <thead className="bg-slate-100 text-slate-700">
          <tr>
            <th className="p-3 text-left">S. No</th>
            <th className="p-3 text-left">Diagnosis</th>
            <th className="p-3 text-center">Suffered Students</th>
          </tr>
        </thead>

                  <tbody className="text-slate-600">
                    <tr className="border-t"> <td className="p-3">1</td> <td className="p-3">PLAQUE</td> <td className="p-3 text-center">374</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">2</td> <td className="p-3">CALCULUS</td> <td className="p-3 text-center">396</td> </tr>
                    <tr className="border-t"> <td className="p-3">3</td> <td className="p-3">CARIES</td> <td className="p-3 text-center">462</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">4</td> <td className="p-3">MISSING TEETH</td> <td className="p-3 text-center">114</td> </tr>
                    <tr className="border-t"> <td className="p-3">5</td> <td className="p-3">MALOCCLUSION</td> <td className="p-3 text-center">106</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">6</td> <td className="p-3">NORMAL</td> <td className="p-3 text-center">748</td> </tr>
                    {/* Total Row */}
                    <tr className="border-t bg-slate-200 font-bold">
                      <td
                        colSpan="2"
                        className="p-3 text-center text-slate-800"
                      >
                        TOTAL NO. OF STUDENTS
                      </td>
                      <td className="p-3 text-center text-slate-800">
                        2200
                      </td>
                    </tr>
                  </tbody>
      </table>
    </div>
  </div>

  {/* IMAGES 12 */}
  <div className="w-full lg:w-1/4 md:w-1/2 flex flex-col gap-4">

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic23}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic24}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

  </div>

</div>
{/* ================= CAMP 13 ================= */}
<motion.p
  initial={{ opacity: 0 }}
  whileInView={{ opacity: 1 }}
  viewport={{ once: true }}
  className="text-slate-600 text-base md:text-lg mb-8 leading-relaxed mt-16"
>
  SARADA RAMAKRISHNA SCHOOL, GANDHINAGAR, VIJAYAWADA
  <br />
  DATE OF THE CHECK UP CAMP: 21.08.2017	
</motion.p>

<div className="flex flex-col lg:flex-row md:flex-row gap-6">

  {/* TABLE 13 */}
  <div className="w-full lg:w-3/4 md:w-1/2">
    <div className="overflow-x-auto">
      <table className="w-full border border-slate-200 rounded-lg overflow-hidden">

        <thead className="bg-slate-100 text-slate-700">
          <tr>
            <th className="p-3 text-left">S. No</th>
            <th className="p-3 text-left">Diagnosis</th>
            <th className="p-3 text-center">Suffered Students</th>
          </tr>
        </thead>

                  <tbody className="text-slate-600">
                    <tr className="border-t"> <td className="p-3">1</td> <td className="p-3">PLAQUE</td> <td className="p-3 text-center">74</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">2</td> <td className="p-3">CALCULUS</td> <td className="p-3 text-center">79</td> </tr>
                    <tr className="border-t"> <td className="p-3">3</td> <td className="p-3">CARIES</td> <td className="p-3 text-center">92</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">4</td> <td className="p-3">MISSING TEETH</td> <td className="p-3 text-center">23</td> </tr>
                    <tr className="border-t"> <td className="p-3">5</td> <td className="p-3">MALOCCLUSION</td> <td className="p-3 text-center">21</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">6</td> <td className="p-3">NORMAL</td> <td className="p-3 text-center">151</td> </tr>
                    {/* Total Row */}
                    <tr className="border-t bg-slate-200 font-bold">
                      <td
                        colSpan="2"
                        className="p-3 text-center text-slate-800"
                      >
                        TOTAL NO. OF STUDENTS
                      </td>
                      <td className="p-3 text-center text-slate-800">
                        440
                      </td>
                    </tr>
                  </tbody>
      </table>
    </div>
  </div>

  {/* IMAGES 13 */}
  <div className="w-full lg:w-1/4 md:w-1/2 flex flex-col gap-4">

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic25}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic26}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

  </div>

</div>
{/* ================= CAMP 14 ================= */}
<motion.p
  initial={{ opacity: 0 }}
  whileInView={{ opacity: 1 }}
  viewport={{ once: true }}
  className="text-slate-600 text-base md:text-lg mb-8 leading-relaxed mt-16"
>
  SARADA DEGREE COLLEGE, GANDHINAGAR, VIJAYAWADA
  <br />
  DATE OF THE CHECK UP CAMP: 21.08.2017	
</motion.p>

<div className="flex flex-col lg:flex-row md:flex-row gap-6">

  {/* TABLE 14 */}
  <div className="w-full lg:w-3/4 md:w-1/2">
    <div className="overflow-x-auto">
      <table className="w-full border border-slate-200 rounded-lg overflow-hidden">

        <thead className="bg-slate-100 text-slate-700">
          <tr>
            <th className="p-3 text-left">S. No</th>
            <th className="p-3 text-left">Diagnosis</th>
            <th className="p-3 text-center">Suffered Students</th>
          </tr>
        </thead>

                  <tbody className="text-slate-600">
                    <tr className="border-t"> <td className="p-3">1</td> <td className="p-3">PLAQUE</td> <td className="p-3 text-center">88</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">2</td> <td className="p-3">CALCULUS</td> <td className="p-3 text-center">93</td> </tr>
                    <tr className="border-t"> <td className="p-3">3</td> <td className="p-3">CARIES</td> <td className="p-3 text-center">109</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">4</td> <td className="p-3">MISSING TEETH</td> <td className="p-3 text-center">29</td> </tr>
                    <tr className="border-t"> <td className="p-3">5</td> <td className="p-3">MALOCCLUSION</td> <td className="p-3 text-center">25</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">6</td> <td className="p-3">NORMAL</td> <td className="p-3 text-center">176</td> </tr>
                    {/* Total Row */}
                    <tr className="border-t bg-slate-200 font-bold">
                      <td
                        colSpan="2"
                        className="p-3 text-center text-slate-800"
                      >
                        TOTAL NO. OF STUDENTS
                      </td>
                      <td className="p-3 text-center text-slate-800">
                        520
                      </td>
                    </tr>
                  </tbody>
      </table>
    </div>
  </div>

  {/* IMAGES 14 */}
  <div className="w-full lg:w-1/4 md:w-1/2 flex flex-col gap-4">

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic27}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic28}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

  </div>

</div>
{/* ================= CAMP 15 ================= */}
<motion.p
  initial={{ opacity: 0 }}
  whileInView={{ opacity: 1 }}
  viewport={{ once: true }}
  className="text-slate-600 text-base md:text-lg mb-8 leading-relaxed mt-16"
>
  NETAJI SCHOOL, BHAVANIPURAM, VIJAYAWADA
  <br />
  DATE OF THE CHECK UP CAMP: 19.08.2017	
</motion.p>

<div className="flex flex-col lg:flex-row md:flex-row gap-6">

  {/* TABLE 15 */}
  <div className="w-full lg:w-3/4 md:w-1/2">
    <div className="overflow-x-auto">
      <table className="w-full border border-slate-200 rounded-lg overflow-hidden">

        <thead className="bg-slate-100 text-slate-700">
          <tr>
            <th className="p-3 text-left">S. No</th>
            <th className="p-3 text-left">Diagnosis</th>
            <th className="p-3 text-center">Suffered Students</th>
          </tr>
        </thead>

                  <tbody className="text-slate-600">
                    <tr className="border-t"> <td className="p-3">1</td> <td className="p-3">PLAQUE</td> <td className="p-3 text-center">187</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">2</td> <td className="p-3">CALCULUS</td> <td className="p-3 text-center">198</td> </tr>
                    <tr className="border-t"> <td className="p-3">3</td> <td className="p-3">CARIES</td> <td className="p-3 text-center">231</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">4</td> <td className="p-3">MISSING TEETH</td> <td className="p-3 text-center">62</td> </tr>
                    <tr className="border-t"> <td className="p-3">5</td> <td className="p-3">MALOCCLUSION</td> <td className="p-3 text-center">48</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">6</td> <td className="p-3">NORMAL</td> <td className="p-3 text-center">374</td> </tr>
                    {/* Total Row */}
                    <tr className="border-t bg-slate-200 font-bold">
                      <td
                        colSpan="2"
                        className="p-3 text-center text-slate-800"
                      >
                        TOTAL NO. OF STUDENTS
                      </td>
                      <td className="p-3 text-center text-slate-800">
                        1100
                      </td>
                    </tr>
                  </tbody>
      </table>
    </div>
  </div>

  {/* IMAGES 15 */}
  <div className="w-full lg:w-1/4 md:w-1/2 flex flex-col gap-4">

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic29}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic30}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

  </div>

</div>
{/* ================= CAMP 16 ================= */}
<motion.p
  initial={{ opacity: 0 }}
  whileInView={{ opacity: 1 }}
  viewport={{ once: true }}
  className="text-slate-600 text-base md:text-lg mb-8 leading-relaxed mt-16"
>
  BISHOP AZARIAH ELE SCHOOL, PUNNAMITHOTA, VIJAYAWADA
  <br />
  DATE OF THE CHECK UP CAMP: 18.08.2017	
</motion.p>

<div className="flex flex-col lg:flex-row md:flex-row gap-6">

  {/* TABLE 16 */}
  <div className="w-full lg:w-3/4 md:w-1/2">
    <div className="overflow-x-auto">
      <table className="w-full border border-slate-200 rounded-lg overflow-hidden">

        <thead className="bg-slate-100 text-slate-700">
          <tr>
            <th className="p-3 text-left">S. No</th>
            <th className="p-3 text-left">Diagnosis</th>
            <th className="p-3 text-center">Suffered Students</th>
          </tr>
        </thead>

                  <tbody className="text-slate-600">
                    <tr className="border-t"> <td className="p-3">1</td> <td className="p-3">PLAQUE</td> <td className="p-3 text-center">31</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">2</td> <td className="p-3">CALCULUS</td> <td className="p-3 text-center">20</td> </tr>
                    <tr className="border-t"> <td className="p-3">3</td> <td className="p-3">CARIES</td> <td className="p-3 text-center">39</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">4</td> <td className="p-3">MISSING TEETH</td> <td className="p-3 text-center">6</td> </tr>
                    <tr className="border-t"> <td className="p-3">5</td> <td className="p-3">MALOCCLUSION</td> <td className="p-3 text-center">4</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">6</td> <td className="p-3">NORMAL</td> <td className="p-3 text-center">15</td> </tr>
                    {/* Total Row */}
                    <tr className="border-t bg-slate-200 font-bold">
                      <td
                        colSpan="2"
                        className="p-3 text-center text-slate-800"
                      >
                        TOTAL NO. OF STUDENTS
                      </td>
                      <td className="p-3 text-center text-slate-800">
                        115
                      </td>
                    </tr>
                  </tbody>
      </table>
    </div>
  </div>

  {/* IMAGES 16 */}
  <div className="w-full lg:w-1/4 md:w-1/2 flex flex-col gap-4">

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic31}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic32}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

  </div>

</div>
{/* ================= CAMP 17 ================= */}
<motion.p
  initial={{ opacity: 0 }}
  whileInView={{ opacity: 1 }}
  viewport={{ once: true }}
  className="text-slate-600 text-base md:text-lg mb-8 leading-relaxed mt-16"
>
  BISHOP AZARIAH E.M HIGH SCHOOL, PUNNAMITHOTA, VIJAYAWADA
  <br />
  DATE OF THE CHECK UP CAMP: 18.08.2017	
</motion.p>

<div className="flex flex-col lg:flex-row md:flex-row gap-6">

  {/* TABLE 17 */}
  <div className="w-full lg:w-3/4 md:w-1/2">
    <div className="overflow-x-auto">
      <table className="w-full border border-slate-200 rounded-lg overflow-hidden">

        <thead className="bg-slate-100 text-slate-700">
          <tr>
            <th className="p-3 text-left">S. No</th>
            <th className="p-3 text-left">Diagnosis</th>
            <th className="p-3 text-center">Suffered Students</th>
          </tr>
        </thead>

                  <tbody className="text-slate-600">
                    <tr className="border-t"> <td className="p-3">1</td> <td className="p-3">PLAQUE</td> <td className="p-3 text-center">40</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">2</td> <td className="p-3">CALCULUS</td> <td className="p-3 text-center">27</td> </tr>
                    <tr className="border-t"> <td className="p-3">3</td> <td className="p-3">CARIES</td> <td className="p-3 text-center">48</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">4</td> <td className="p-3">MISSING TEETH</td> <td className="p-3 text-center">6</td> </tr>
                    <tr className="border-t"> <td className="p-3">5</td> <td className="p-3">MALOCCLUSION</td> <td className="p-3 text-center">10</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">6</td> <td className="p-3">NORMAL</td> <td className="p-3 text-center">19</td> </tr>
                    {/* Total Row */}
                    <tr className="border-t bg-slate-200 font-bold">
                      <td
                        colSpan="2"
                        className="p-3 text-center text-slate-800"
                      >
                        TOTAL NO. OF STUDENTS
                      </td>
                      <td className="p-3 text-center text-slate-800">
                        150
                      </td>
                    </tr>
                  </tbody>
      </table>
    </div>
  </div>

  {/* IMAGES 17 */}
  <div className="w-full lg:w-1/4 md:w-1/2 flex flex-col gap-4">

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic33}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic34}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

  </div>

</div>
{/* ================= CAMP 18 ================= */}
<motion.p
  initial={{ opacity: 0 }}
  whileInView={{ opacity: 1 }}
  viewport={{ once: true }}
  className="text-slate-600 text-base md:text-lg mb-8 leading-relaxed mt-16"
>
  BISHOP AZARIAH HIGH SCHOOL, PUNNAMITHOTA, VIJAYAWADA
  <br />
  DATE OF THE CHECK UP CAMP: 18.08.2017	
</motion.p>

<div className="flex flex-col lg:flex-row md:flex-row gap-6">

  {/* TABLE 18 */}
  <div className="w-full lg:w-3/4 md:w-1/2">
    <div className="overflow-x-auto">
      <table className="w-full border border-slate-200 rounded-lg overflow-hidden">

        <thead className="bg-slate-100 text-slate-700">
          <tr>
            <th className="p-3 text-left">S. No</th>
            <th className="p-3 text-left">Diagnosis</th>
            <th className="p-3 text-center">Suffered Students</th>
          </tr>
        </thead>

                  <tbody className="text-slate-600">
                    <tr className="border-t"> <td className="p-3">1</td> <td className="p-3">PLAQUE</td> <td className="p-3 text-center">64</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">2</td> <td className="p-3">CALCULUS</td> <td className="p-3 text-center">78</td> </tr>
                    <tr className="border-t"> <td className="p-3">3</td> <td className="p-3">CARIES</td> <td className="p-3 text-center">90</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">4</td> <td className="p-3">MISSING TEETH</td> <td className="p-3 text-center">23</td> </tr>
                    <tr className="border-t"> <td className="p-3">5</td> <td className="p-3">MALOCCLUSION</td> <td className="p-3 text-center">20</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">6</td> <td className="p-3">NORMAL</td> <td className="p-3 text-center">157</td> </tr>
                    {/* Total Row */}
                    <tr className="border-t bg-slate-200 font-bold">
                      <td
                        colSpan="2"
                        className="p-3 text-center text-slate-800"
                      >
                        TOTAL NO. OF STUDENTS
                      </td>
                      <td className="p-3 text-center text-slate-800">
                        432
                      </td>
                    </tr>
                  </tbody>
      </table>
    </div>
  </div>

  {/* IMAGES 18 */}
  <div className="w-full lg:w-1/4 md:w-1/2 flex flex-col gap-4">

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic35}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic36}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

  </div>

</div>
{/* ================= CAMP 19 ================= */}
<motion.p
  initial={{ opacity: 0 }}
  whileInView={{ opacity: 1 }}
  viewport={{ once: true }}
  className="text-slate-600 text-base md:text-lg mb-8 leading-relaxed mt-16"
>
  A.D.M.C. HIGH SCHOOL, KOTHAPETA, VIJAYAWADA
  <br />
  DATE OF THE CHECK UP CAMP: 17.08.2017	
</motion.p>

<div className="flex flex-col lg:flex-row md:flex-row gap-6">

  {/* TABLE 19 */}
  <div className="w-full lg:w-3/4 md:w-1/2">
    <div className="overflow-x-auto">
      <table className="w-full border border-slate-200 rounded-lg overflow-hidden">

        <thead className="bg-slate-100 text-slate-700">
          <tr>
            <th className="p-3 text-left">S. No</th>
            <th className="p-3 text-left">Diagnosis</th>
            <th className="p-3 text-center">Suffered Students</th>
          </tr>
        </thead>

                  <tbody className="text-slate-600">
                    <tr className="border-t"> <td className="p-3">1</td> <td className="p-3">PLAQUE</td> <td className="p-3 text-center">79</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">2</td> <td className="p-3">CALCULUS</td> <td className="p-3 text-center">53</td> </tr>
                    <tr className="border-t"> <td className="p-3">3</td> <td className="p-3">CARIES</td> <td className="p-3 text-center">94</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">4</td> <td className="p-3">MISSING TEETH</td> <td className="p-3 text-center">15</td> </tr>
                    <tr className="border-t"> <td className="p-3">5</td> <td className="p-3">MALOCCLUSION</td> <td className="p-3 text-center">14</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">6</td> <td className="p-3">NORMAL</td> <td className="p-3 text-center">38</td> </tr>
                    {/* Total Row */}
                    <tr className="border-t bg-slate-200 font-bold">
                      <td
                        colSpan="2"
                        className="p-3 text-center text-slate-800"
                      >
                        TOTAL NO. OF STUDENTS
                      </td>
                      <td className="p-3 text-center text-slate-800">
                        293
                      </td>
                    </tr>
                  </tbody>
      </table>
    </div>
  </div>

  {/* IMAGES 19 */}
  <div className="w-full lg:w-1/4 md:w-1/2 flex flex-col gap-4">

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic37}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic38}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

  </div>

</div>
{/* ================= CAMP 20 ================= */}
<motion.p
  initial={{ opacity: 0 }}
  whileInView={{ opacity: 1 }}
  viewport={{ once: true }}
  className="text-slate-600 text-base md:text-lg mb-8 leading-relaxed mt-16"
>
  A.D.M.C.ELE SCHOOL, KOTHAPETA, VIJAYAWADA
  <br />
  DATE OF THE CHECK UP CAMP: 17.08.2017	
</motion.p>

<div className="flex flex-col lg:flex-row md:flex-row gap-6">

  {/* TABLE 20 */}
  <div className="w-full lg:w-3/4 md:w-1/2">
    <div className="overflow-x-auto">
      <table className="w-full border border-slate-200 rounded-lg overflow-hidden">

        <thead className="bg-slate-100 text-slate-700">
          <tr>
            <th className="p-3 text-left">S. No</th>
            <th className="p-3 text-left">Diagnosis</th>
            <th className="p-3 text-center">Suffered Students</th>
          </tr>
        </thead>

                  <tbody className="text-slate-600">
                    <tr className="border-t"> <td className="p-3">1</td> <td className="p-3">PLAQUE</td> <td className="p-3 text-center">55</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">2</td> <td className="p-3">CALCULUS</td> <td className="p-3 text-center">36</td> </tr>
                    <tr className="border-t"> <td className="p-3">3</td> <td className="p-3">CARIES</td> <td className="p-3 text-center">65</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">4</td> <td className="p-3">MISSING TEETH</td> <td className="p-3 text-center">9</td> </tr>
                    <tr className="border-t"> <td className="p-3">5</td> <td className="p-3">MALOCCLUSION</td> <td className="p-3 text-center">12</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">6</td> <td className="p-3">NORMAL</td> <td className="p-3 text-center">26</td> </tr>
                    {/* Total Row */}
                    <tr className="border-t bg-slate-200 font-bold">
                      <td
                        colSpan="2"
                        className="p-3 text-center text-slate-800"
                      >
                        TOTAL NO. OF STUDENTS
                      </td>
                      <td className="p-3 text-center text-slate-800">
                        203
                      </td>
                    </tr>
                  </tbody>
      </table>
    </div>
  </div>

  {/* IMAGES 20 */}
  <div className="w-full lg:w-1/4 md:w-1/2 flex flex-col gap-4">

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic39}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic40}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

  </div>

</div>
{/* ================= CAMP 21 ================= */}
<motion.p
  initial={{ opacity: 0 }}
  whileInView={{ opacity: 1 }}
  viewport={{ once: true }}
  className="text-slate-600 text-base md:text-lg mb-8 leading-relaxed mt-16"
>
  S.B.V.S.R.M.C.ELE SCHOOL, KANDRIKA, VIJAYAWADA
  <br />
  DATE OF THE CHECK UP CAMP: 16.08.2017	
</motion.p>

<div className="flex flex-col lg:flex-row md:flex-row gap-6">

  {/* TABLE 21 */}
  <div className="w-full lg:w-3/4 md:w-1/2">
    <div className="overflow-x-auto">
      <table className="w-full border border-slate-200 rounded-lg overflow-hidden">

        <thead className="bg-slate-100 text-slate-700">
          <tr>
            <th className="p-3 text-left">S. No</th>
            <th className="p-3 text-left">Diagnosis</th>
            <th className="p-3 text-center">Suffered Students</th>
          </tr>
        </thead>

                  <tbody className="text-slate-600">
                    <tr className="border-t"> <td className="p-3">1</td> <td className="p-3">PLAQUE</td> <td className="p-3 text-center">64</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">2</td> <td className="p-3">CALCULUS</td> <td className="p-3 text-center">43</td> </tr>
                    <tr className="border-t"> <td className="p-3">3</td> <td className="p-3">CARIES</td> <td className="p-3 text-center">76</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">4</td> <td className="p-3">MISSING TEETH</td> <td className="p-3 text-center">13</td> </tr>
                    <tr className="border-t"> <td className="p-3">5</td> <td className="p-3">MALOCCLUSION</td> <td className="p-3 text-center">10</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">6</td> <td className="p-3">NORMAL</td> <td className="p-3 text-center">31</td> </tr>
                    {/* Total Row */}
                    <tr className="border-t bg-slate-200 font-bold">
                      <td
                        colSpan="2"
                        className="p-3 text-center text-slate-800"
                      >
                        TOTAL NO. OF STUDENTS
                      </td>
                      <td className="p-3 text-center text-slate-800">
                        237
                      </td>
                    </tr>
                  </tbody>
      </table>
    </div>
  </div>

  {/* IMAGES 21 */}
  <div className="w-full lg:w-1/4 md:w-1/2 flex flex-col gap-4">

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic41}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic42}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

  </div>

</div>
{/* ================= CAMP 22 ================= */}
<motion.p
  initial={{ opacity: 0 }}
  whileInView={{ opacity: 1 }}
  viewport={{ once: true }}
  className="text-slate-600 text-base md:text-lg mb-8 leading-relaxed mt-16"
>
  A.P.J. ABDUL KALAM M.C.H. SCHOOL, ARUNDALPET, VIJAYAWADA
  <br />
  DATE OF THE CHECK UP CAMP: 16.08.2017	
</motion.p>

<div className="flex flex-col lg:flex-row md:flex-row gap-6">

  {/* TABLE 22 */}
  <div className="w-full lg:w-3/4 md:w-1/2">
    <div className="overflow-x-auto">
      <table className="w-full border border-slate-200 rounded-lg overflow-hidden">

        <thead className="bg-slate-100 text-slate-700">
          <tr>
            <th className="p-3 text-left">S. No</th>
            <th className="p-3 text-left">Diagnosis</th>
            <th className="p-3 text-center">Suffered Students</th>
          </tr>
        </thead>

                  <tbody className="text-slate-600">
                    <tr className="border-t"> <td className="p-3">1</td> <td className="p-3">PLAQUE</td> <td className="p-3 text-center">18</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">2</td> <td className="p-3">CALCULUS</td> <td className="p-3 text-center">12</td> </tr>
                    <tr className="border-t"> <td className="p-3">3</td> <td className="p-3">CARIES</td> <td className="p-3 text-center">21</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">4</td> <td className="p-3">MISSING TEETH</td> <td className="p-3 text-center">4</td> </tr>
                    <tr className="border-t"> <td className="p-3">5</td> <td className="p-3">MALOCCLUSION</td> <td className="p-3 text-center">2</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">6</td> <td className="p-3">NORMAL</td> <td className="p-3 text-center">9</td> </tr>
                    {/* Total Row */}
                    <tr className="border-t bg-slate-200 font-bold">
                      <td
                        colSpan="2"
                        className="p-3 text-center text-slate-800"
                      >
                        TOTAL NO. OF STUDENTS
                      </td>
                      <td className="p-3 text-center text-slate-800">
                        66
                      </td>
                    </tr>
                  </tbody>
      </table>
    </div>
  </div>

  {/* IMAGES 22 */}
  <div className="w-full lg:w-1/4 md:w-1/2 flex flex-col gap-4">

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic43}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic44}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

  </div>

</div>

{/* ================= CAMP 23 ================= */}
<motion.p
  initial={{ opacity: 0 }}
  whileInView={{ opacity: 1 }}
  viewport={{ once: true }}
  className="text-slate-600 text-base md:text-lg mb-8 leading-relaxed mt-16"
>
  M.C. URDU ELE SCHOOL, ARUNDALPET, VIJAYAWADA
  <br />
  DATE OF THE CHECK UP CAMP: 16.08.2017	
</motion.p>

<div className="flex flex-col lg:flex-row md:flex-row gap-6">

  {/* TABLE 23 */}
  <div className="w-full lg:w-3/4 md:w-1/2">
    <div className="overflow-x-auto">
      <table className="w-full border border-slate-200 rounded-lg overflow-hidden">

        <thead className="bg-slate-100 text-slate-700">
          <tr>
            <th className="p-3 text-left">S. No</th>
            <th className="p-3 text-left">Diagnosis</th>
            <th className="p-3 text-center">Suffered Students</th>
          </tr>
        </thead>

                  <tbody className="text-slate-600">
                    <tr className="border-t"> <td className="p-3">1</td> <td className="p-3">PLAQUE</td> <td className="p-3 text-center">3</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">2</td> <td className="p-3">CALCULUS</td> <td className="p-3 text-center">2</td> </tr>
                    <tr className="border-t"> <td className="p-3">3</td> <td className="p-3">CARIES</td> <td className="p-3 text-center">2</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">4</td> <td className="p-3">MISSING TEETH</td> <td className="p-3 text-center">-</td> </tr>
                    <tr className="border-t"> <td className="p-3">5</td> <td className="p-3">MALOCCLUSION</td> <td className="p-3 text-center">2</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">6</td> <td className="p-3">NORMAL</td> <td className="p-3 text-center">1</td> </tr>
                    {/* Total Row */}
                    <tr className="border-t bg-slate-200 font-bold">
                      <td
                        colSpan="2"
                        className="p-3 text-center text-slate-800"
                      >
                        TOTAL NO. OF STUDENTS
                      </td>
                      <td className="p-3 text-center text-slate-800">
                        10
                      </td>
                    </tr>
                  </tbody>
      </table>
    </div>
  </div>

  {/* IMAGES 23 */}
  <div className="w-full lg:w-1/4 md:w-1/2 flex flex-col gap-4">

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic45}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic46}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

  </div>

</div>
{/* ================= CAMP 24 ================= */}
<motion.p
  initial={{ opacity: 0 }}
  whileInView={{ opacity: 1 }}
  viewport={{ once: true }}
  className="text-slate-600 text-base md:text-lg mb-8 leading-relaxed mt-16"
>
  CARE & SHARE.M.C. HIGH SCHOOL, NEW R.R.PET, VIJAYAWADA
  <br />
  DATE OF THE CHECK UP CAMP: 11.08.2017	
</motion.p>

<div className="flex flex-col lg:flex-row md:flex-row gap-6">

  {/* TABLE 24 */}
  <div className="w-full lg:w-3/4 md:w-1/2">
    <div className="overflow-x-auto">
      <table className="w-full border border-slate-200 rounded-lg overflow-hidden">

        <thead className="bg-slate-100 text-slate-700">
          <tr>
            <th className="p-3 text-left">S. No</th>
            <th className="p-3 text-left">Diagnosis</th>
            <th className="p-3 text-center">Suffered Students</th>
          </tr>
        </thead>

                  <tbody className="text-slate-600">
                    <tr className="border-t"> <td className="p-3">1</td> <td className="p-3">PLAQUE</td> <td className="p-3 text-center">77</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">2</td> <td className="p-3">CALCULUS</td> <td className="p-3 text-center">74</td> </tr>
                    <tr className="border-t"> <td className="p-3">3</td> <td className="p-3">CARIES</td> <td className="p-3 text-center">86</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">4</td> <td className="p-3">MISSING TEETH</td> <td className="p-3 text-center">19</td> </tr>
                    <tr className="border-t"> <td className="p-3">5</td> <td className="p-3">MALOCCLUSION</td> <td className="p-3 text-center">22</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">6</td> <td className="p-3">NORMAL</td> <td className="p-3 text-center">132</td> </tr>
                    {/* Total Row */}
                    <tr className="border-t bg-slate-200 font-bold">
                      <td
                        colSpan="2"
                        className="p-3 text-center text-slate-800"
                      >
                        TOTAL NO. OF STUDENTS
                      </td>
                      <td className="p-3 text-center text-slate-800">
                        410
                      </td>
                    </tr>
                  </tbody>
      </table>
    </div>
  </div>

  {/* IMAGES 24 */}
  <div className="w-full lg:w-1/4 md:w-1/2 flex flex-col gap-4">

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic47}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic48}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

  </div>

</div>
{/* ================= CAMP 25 ================= */}
<motion.p
  initial={{ opacity: 0 }}
  whileInView={{ opacity: 1 }}
  viewport={{ once: true }}
  className="text-slate-600 text-base md:text-lg mb-8 leading-relaxed mt-16"
>
  CARE & SHARE.M.C.ELE SCHOOL, NEW R.R.PET, VIJAYAWADA
  <br />
  DATE OF THE CHECK UP CAMP: 11.08.2017	
</motion.p>

<div className="flex flex-col lg:flex-row md:flex-row gap-6">

  {/* TABLE 25 */}
  <div className="w-full lg:w-3/4 md:w-1/2">
    <div className="overflow-x-auto">
      <table className="w-full border border-slate-200 rounded-lg overflow-hidden">

        <thead className="bg-slate-100 text-slate-700">
          <tr>
            <th className="p-3 text-left">S. No</th>
            <th className="p-3 text-left">Diagnosis</th>
            <th className="p-3 text-center">Suffered Students</th>
          </tr>
        </thead>

                  <tbody className="text-slate-600">
                    <tr className="border-t"> <td className="p-3">1</td> <td className="p-3">PLAQUE</td> <td className="p-3 text-center">76</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">2</td> <td className="p-3">CALCULUS</td> <td className="p-3 text-center">72</td> </tr>
                    <tr className="border-t"> <td className="p-3">3</td> <td className="p-3">CARIES</td> <td className="p-3 text-center">84</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">4</td> <td className="p-3">MISSING TEETH</td> <td className="p-3 text-center">22</td> </tr>
                    <tr className="border-t"> <td className="p-3">5</td> <td className="p-3">MALOCCLUSION</td> <td className="p-3 text-center">18</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">6</td> <td className="p-3">NORMAL</td> <td className="p-3 text-center">128</td> </tr>
                    {/* Total Row */}
                    <tr className="border-t bg-slate-200 font-bold">
                      <td
                        colSpan="2"
                        className="p-3 text-center text-slate-800"
                      >
                        TOTAL NO. OF STUDENTS
                      </td>
                      <td className="p-3 text-center text-slate-800">
                        400
                      </td>
                    </tr>
                  </tbody>
      </table>
    </div>
  </div>

  {/* IMAGES 25 */}
  <div className="w-full lg:w-1/4 md:w-1/2 flex flex-col gap-4">

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic49}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic50}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

  </div>

</div>
{/* ================= CAMP 26 ================= */}
<motion.p
  initial={{ opacity: 0 }}
  whileInView={{ opacity: 1 }}
  viewport={{ once: true }}
  className="text-slate-600 text-base md:text-lg mb-8 leading-relaxed mt-16"
>
  SRI B.V. SUBBA REDDY.M.C.H. SCHOOL, KANDRIKA, VIJAYAWADA
  <br />
  DATE OF THE CHECK UP CAMP: 09.08.2017	
</motion.p>

<div className="flex flex-col lg:flex-row md:flex-row gap-6">

  {/* TABLE 26 */}
  <div className="w-full lg:w-3/4 md:w-1/2">
    <div className="overflow-x-auto">
      <table className="w-full border border-slate-200 rounded-lg overflow-hidden">

        <thead className="bg-slate-100 text-slate-700">
          <tr>
            <th className="p-3 text-left">S. No</th>
            <th className="p-3 text-left">Diagnosis</th>
            <th className="p-3 text-center">Suffered Students</th>
          </tr>
        </thead>

                  <tbody className="text-slate-600">
                    <tr className="border-t"> <td className="p-3">1</td> <td className="p-3">PLAQUE</td> <td className="p-3 text-center">116</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">2</td> <td className="p-3">CALCULUS</td> <td className="p-3 text-center">104</td> </tr>
                    <tr className="border-t"> <td className="p-3">3</td> <td className="p-3">CARIES</td> <td className="p-3 text-center">121</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">4</td> <td className="p-3">MISSING TEETH</td> <td className="p-3 text-center">25</td> </tr>
                    <tr className="border-t"> <td className="p-3">5</td> <td className="p-3">MALOCCLUSION</td> <td className="p-3 text-center">35</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">6</td> <td className="p-3">NORMAL</td> <td className="p-3 text-center">179</td> </tr>
                    {/* Total Row */}
                    <tr className="border-t bg-slate-200 font-bold">
                      <td
                        colSpan="2"
                        className="p-3 text-center text-slate-800"
                      >
                        TOTAL NO. OF STUDENTS
                      </td>
                      <td className="p-3 text-center text-slate-800">
                        580
                      </td>
                    </tr>
                  </tbody>
      </table>
    </div>
  </div>

  {/* IMAGES 26 */}
  <div className="w-full lg:w-1/4 md:w-1/2 flex flex-col gap-4">

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic51}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic52}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

  </div>

</div>
{/* ================= CAMP 27 ================= */}
<motion.p
  initial={{ opacity: 0 }}
  whileInView={{ opacity: 1 }}
  viewport={{ once: true }}
  className="text-slate-600 text-base md:text-lg mb-8 leading-relaxed mt-16"
>
  MK.BAIG.M.C.ELE SCHOOL, AJITH SINGH NAGAR, VIJAYAWADA
  <br />
  DATE OF THE CHECK UP CAMP: 08.08.2017	
</motion.p>

<div className="flex flex-col lg:flex-row md:flex-row gap-6">

  {/* TABLE 27 */}
  <div className="w-full lg:w-3/4 md:w-1/2">
    <div className="overflow-x-auto">
      <table className="w-full border border-slate-200 rounded-lg overflow-hidden">

        <thead className="bg-slate-100 text-slate-700">
          <tr>
            <th className="p-3 text-left">S. No</th>
            <th className="p-3 text-left">Diagnosis</th>
            <th className="p-3 text-center">Suffered Students</th>
          </tr>
        </thead>

                  <tbody className="text-slate-600">
                    <tr className="border-t"> <td className="p-3">1</td> <td className="p-3">PLAQUE</td> <td className="p-3 text-center">46</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">2</td> <td className="p-3">CALCULUS</td> <td className="p-3 text-center">44</td> </tr>
                    <tr className="border-t"> <td className="p-3">3</td> <td className="p-3">CARIES</td> <td className="p-3 text-center">55</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">4</td> <td className="p-3">MISSING TEETH</td> <td className="p-3 text-center">10</td> </tr>
                    <tr className="border-t"> <td className="p-3">5</td> <td className="p-3">MALOCCLUSION</td> <td className="p-3 text-center">13</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">6</td> <td className="p-3">NORMAL</td> <td className="p-3 text-center">75</td> </tr>
                    {/* Total Row */}
                    <tr className="border-t bg-slate-200 font-bold">
                      <td
                        colSpan="2"
                        className="p-3 text-center text-slate-800"
                      >
                        TOTAL NO. OF STUDENTS
                      </td>
                      <td className="p-3 text-center text-slate-800">
                        243
                      </td>
                    </tr>
                  </tbody>
      </table>
    </div>
  </div>

  {/* IMAGES 28 */}
  <div className="w-full lg:w-1/4 md:w-1/2 flex flex-col gap-4">

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic53}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic54}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

  </div>

</div>
{/* ================= CAMP 28 ================= */}
<motion.p
  initial={{ opacity: 0 }}
  whileInView={{ opacity: 1 }}
  viewport={{ once: true }}
  className="text-slate-600 text-base md:text-lg mb-8 leading-relaxed mt-16"
>
  MK. BAIG.M.C. HIGH SCHOOL, AJITH SINGH NAGAR, VIJAYAWADA
  <br />
  DATE OF THE CHECK UP CAMP: 08.08.2017	
</motion.p>

<div className="flex flex-col lg:flex-row md:flex-row gap-6">

  {/* TABLE 23 */}
  <div className="w-full lg:w-3/4 md:w-1/2">
    <div className="overflow-x-auto">
      <table className="w-full border border-slate-200 rounded-lg overflow-hidden">

        <thead className="bg-slate-100 text-slate-700">
          <tr>
            <th className="p-3 text-left">S. No</th>
            <th className="p-3 text-left">Diagnosis</th>
            <th className="p-3 text-center">Suffered Students</th>
          </tr>
        </thead>

                  <tbody className="text-slate-600">
                    <tr className="border-t"> <td className="p-3">1</td> <td className="p-3">PLAQUE</td> <td className="p-3 text-center">83</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">2</td> <td className="p-3">CALCULUS</td> <td className="p-3 text-center">79</td> </tr>
                    <tr className="border-t"> <td className="p-3">3</td> <td className="p-3">CARIES</td> <td className="p-3 text-center">92</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">4</td> <td className="p-3">MISSING TEETH</td> <td className="p-3 text-center">24</td> </tr>
                    <tr className="border-t"> <td className="p-3">5</td> <td className="p-3">MALOCCLUSION</td> <td className="p-3 text-center">20</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">6</td> <td className="p-3">NORMAL</td> <td className="p-3 text-center">142</td> </tr>
                    {/* Total Row */}
                    <tr className="border-t bg-slate-200 font-bold">
                      <td
                        colSpan="2"
                        className="p-3 text-center text-slate-800"
                      >
                        TOTAL NO. OF STUDENTS
                      </td>
                      <td className="p-3 text-center text-slate-800">
                        440
                      </td>
                    </tr>
                  </tbody>
      </table>
    </div>
  </div>

  {/* IMAGES 28 */}
  <div className="w-full lg:w-1/4 md:w-1/2 flex flex-col gap-4">

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic55}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic56}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

  </div>

</div>
{/* ================= CAMP 29 ================= */}
<motion.p
  initial={{ opacity: 0 }}
  whileInView={{ opacity: 1 }}
  viewport={{ once: true }}
  className="text-slate-600 text-base md:text-lg mb-8 leading-relaxed mt-16"
>
  C.P.R.Z.P.H. SCHOOL, VELAGALERU, G. KONDURU
  <br />
  DATE OF THE CHECK UP CAMP: 07.08.2017	
</motion.p>

<div className="flex flex-col lg:flex-row md:flex-row gap-6">

  {/* TABLE 29 */}
  <div className="w-full lg:w-3/4 md:w-1/2">
    <div className="overflow-x-auto">
      <table className="w-full border border-slate-200 rounded-lg overflow-hidden">

        <thead className="bg-slate-100 text-slate-700">
          <tr>
            <th className="p-3 text-left">S. No</th>
            <th className="p-3 text-left">Diagnosis</th>
            <th className="p-3 text-center">Suffered Students</th>
          </tr>
        </thead>

                  <tbody className="text-slate-600">
                    <tr className="border-t"> <td className="p-3">1</td> <td className="p-3">PLAQUE</td> <td className="p-3 text-center">62</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">2</td> <td className="p-3">CALCULUS</td> <td className="p-3 text-center">41</td> </tr>
                    <tr className="border-t"> <td className="p-3">3</td> <td className="p-3">CARIES</td> <td className="p-3 text-center">74</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">4</td> <td className="p-3">MISSING TEETH</td> <td className="p-3 text-center">13</td> </tr>
                    <tr className="border-t"> <td className="p-3">5</td> <td className="p-3">MALOCCLUSION</td> <td className="p-3 text-center">10</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">6</td> <td className="p-3">NORMAL</td> <td className="p-3 text-center">30</td> </tr>
                    {/* Total Row */}
                    <tr className="border-t bg-slate-200 font-bold">
                      <td
                        colSpan="2"
                        className="p-3 text-center text-slate-800"
                      >
                        TOTAL NO. OF STUDENTS
                      </td>
                      <td className="p-3 text-center text-slate-800">
                        230
                      </td>
                    </tr>
                  </tbody>
      </table>
    </div>
  </div>

  {/* IMAGES 29 */}
  <div className="w-full lg:w-1/4 md:w-1/2 flex flex-col gap-4">

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic57}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic58}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

  </div>

</div>
{/* ================= CAMP 30 ================= */}
<motion.p
  initial={{ opacity: 0 }}
  whileInView={{ opacity: 1 }}
  viewport={{ once: true }}
  className="text-slate-600 text-base md:text-lg mb-8 leading-relaxed mt-16"
>
  DR.JD.M.M.C.ELE SCHOOL, VAMBAY COLONY, VIJAYAWADA
  <br />
  DATE OF THE CHECK UP CAMP: 05.08.2017		
</motion.p>

<div className="flex flex-col lg:flex-row md:flex-row gap-6">

  {/* TABLE 30 */}
  <div className="w-full lg:w-3/4 md:w-1/2">
    <div className="overflow-x-auto">
      <table className="w-full border border-slate-200 rounded-lg overflow-hidden">

        <thead className="bg-slate-100 text-slate-700">
          <tr>
            <th className="p-3 text-left">S. No</th>
            <th className="p-3 text-left">Diagnosis</th>
            <th className="p-3 text-center">Suffered Students</th>
          </tr>
        </thead>

                  <tbody className="text-slate-600">
                    <tr className="border-t"> <td className="p-3">1</td> <td className="p-3">PLAQUE</td> <td className="p-3 text-center">66</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">2</td> <td className="p-3">CALCULUS</td> <td className="p-3 text-center">63</td> </tr>
                    <tr className="border-t"> <td className="p-3">3</td> <td className="p-3">CARIES</td> <td className="p-3 text-center">73</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">4</td> <td className="p-3">MISSING TEETH</td> <td className="p-3 text-center">21</td> </tr>
                    <tr className="border-t"> <td className="p-3">5</td> <td className="p-3">MALOCCLUSION</td> <td className="p-3 text-center">15</td> </tr>
                    <tr className="border-t bg-slate-50"> <td className="p-3">6</td> <td className="p-3">NORMAL</td> <td className="p-3 text-center">112</td> </tr>
                    {/* Total Row */}
                    <tr className="border-t bg-slate-200 font-bold">
                      <td
                        colSpan="2"
                        className="p-3 text-center text-slate-800"
                      >
                        TOTAL NO. OF STUDENTS
                      </td>
                      <td className="p-3 text-center text-slate-800">
                        350
                      </td>
                    </tr>
                  </tbody>
      </table>
    </div>
  </div>

  {/* IMAGES 30 */}
  <div className="w-full lg:w-1/4 md:w-1/2 flex flex-col gap-4">

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic59}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

    <motion.div
      whileHover={{ scale: 1.03 }}
      className="rounded-xl overflow-hidden shadow-md"
    >
      <img
        src={pic60}
        alt=""
        className="w-full h-48 object-cover"
      />
    </motion.div>

  </div>

</div>


















        </div>
      </section>

      <Footer />
    </>
  );
};

export default CampDetails;